import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import {
  saveConfigurationComplete,
  setConfigurationChanged,
  setCurrentConfigCode,
  setPopupState,
} from '../model/configuratorSlice';
import { AccessTokenAuth } from '../auth/AccessTokenAuth';
import { EndPoints, PopupState } from '../model/constants';
import { FeatureSelectionUtility } from '../utilities/FeatureSelectionUtility';


export default function SaveConfigurationService() {
  const {
    promotionSlug, user, currentUnit, categories, configurationChanged, currentConfigCode,
  } = useSelector(state => state.configurator);

  const dispatch = useDispatch();

  const onSuccessResponse = (code, onSuccessResponseCallback) => {
    dispatch(setCurrentConfigCode(code));
    dispatch(setConfigurationChanged(false));

    if (onSuccessResponseCallback !== undefined) {
      onSuccessResponseCallback(code);
    } else {
      dispatch(setPopupState(PopupState.SaveConfiguration));
      dispatch(saveConfigurationComplete());
    }
  };

  return useMutation(['saveConfigurationQuery'], (onSuccessCallback) => {
    if (!configurationChanged && currentConfigCode !== '') {
      onSuccessResponse(currentConfigCode, onSuccessCallback);
    } else {
      const unitId = currentUnit !== null ? currentUnit.id : 0;
      const saveConfigurationUrl = `${EndPoints.SaveConfig}/${promotionSlug}/unit/${unitId}`;
      const featureSelection = FeatureSelectionUtility.CreateFeatureSelection(categories);
      const data = {
        promotion_slug: promotionSlug,
        id_users: user !== null ? user.id : 0,
        id_units: currentUnit !== null ? currentUnit.id : 0,
        feature_selection: featureSelection,
      };
      const config = {
        headers: {
          [AccessTokenAuth.HeaderName]: AccessTokenAuth.GetHeaderValue(),
        },
      };
      axios
        .post(saveConfigurationUrl, data, config)
        .then((response) => {
          onSuccessResponse(response.data.code, onSuccessCallback);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  });
}
